<template>
  <search-group-form-page
      :resource-name="resourceName"
      :url="`projects/${project_id}/searches/tag_library`"
      :item_id="null"
      :item="model"
      :title="$t('booleanSearch.new_bool_tagSearch')"
      :detail-fields="detailFields"
      :hide-filters="true"
      :is-busy="isBusy"
  />
</template>

<script>

// Plugins
import { mapState } from "vuex";

// Const
import { tagSearchQuery } from '../../config/bool-const'

// Components
import SearchGroupFormPage from "../../components/boolean-search/SearchGroupFormPage.vue";

export default {
  name: "create-tag-search",

  data() {
    return {
      resourceName: 'tag_library',
      model: { ...tagSearchQuery },
    }
  },

  computed: {
    ...mapState({
      tag_library: state => state.booleanSearch.tag_library,
    }),
    project_id() { return this.$store.state.booleanSearch.project_id },
    isBusy() { return this.$store.state.booleanSearch.isBusy },
    detailFields() { 
      return ['name', 'multiSyntax', 'boolTagCategory'].concat(this.tag_library.showPrivateTags ? ['isPrivateTag'] : []) 
    },
  },

  components: {
    SearchGroupFormPage,
  }
}
</script>